// extracted by mini-css-extract-plugin
module.exports = {"report_summary_overview_container":"_2q0p0Yr","overview_column_header":"_38GAb2f"};